// extracted by mini-css-extract-plugin
module.exports = {"footerNavWrapper":"style-module--footerNavWrapper--nt2gz","footerNav":"style-module--footerNav--3VDAi","footerNavLink":"style-module--footerNavLink--2pVTr"};